// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__i1vK_","buttons":"Footer_buttons__1MQOQ"};